export type LocalPaymentReceipt = {
  version: 1;
  receiptId: string;
  signature: string;
  mint: string;
  sender: string;
  recipient: string;
  amountBaseUnits: string;
  amountDisplay: string;
  cluster: string;
  confirmedAt: string;
  status: 'confirmed';
};

function bytesToHex(bytes: Uint8Array): string {
  return [...bytes].map((byte) => byte.toString(16).padStart(2, '0')).join('');
}

export async function createLocalPaymentReceipt(input: Omit<LocalPaymentReceipt, 'version' | 'receiptId' | 'status'>) {
  const canonical = [
    'black-btc-payment-receipt-v1',
    input.signature,
    input.mint,
    input.sender,
    input.recipient,
    input.amountBaseUnits,
    input.cluster,
  ].join('|');
  const digest = await crypto.subtle.digest('SHA-256', new TextEncoder().encode(canonical));
  return Object.freeze({
    version: 1 as const,
    receiptId: `0x${bytesToHex(new Uint8Array(digest))}`,
    ...input,
    status: 'confirmed' as const,
  });
}

export function explorerTransactionUrl(signature: string, cluster: string): string {
  const query = cluster === 'devnet' ? '?cluster=devnet' : '';
  return `https://explorer.solana.com/tx/${encodeURIComponent(signature)}${query}`;
}

export function loadReceipts(): LocalPaymentReceipt[] {
  try {
    const parsed = JSON.parse(localStorage.getItem('black-btc.payment-receipts.v1') ?? '[]');
    return Array.isArray(parsed) ? parsed.slice(0, 20) : [];
  } catch {
    return [];
  }
}

export function storeReceipt(receipt: LocalPaymentReceipt): void {
  const next = [receipt, ...loadReceipts().filter((item) => item.signature !== receipt.signature)].slice(0, 20);
  localStorage.setItem('black-btc.payment-receipts.v1', JSON.stringify(next));
}


